import React from 'react'
import { AudioProvider } from './podcast/audio/AudioProvider'

const RootElement = ({ children }: React.PropsWithChildren) => {
  return <AudioProvider>{children}</AudioProvider>
}

export default RootElement
